// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Dropdown_dropdown__sed5f","content":"Dropdown_content__TfSaE","overlay":"Dropdown_overlay__1jVjm"};